import React, { useEffect, useRef, useState } from "react";
import "./styles.css";
import SilverButton from "../../buttons/SilverButton";

const Popup = ({
                   direction = "bottom",
                   panelAlign = { horizontal: "left", vertical: "bottom" },
                   trigger = null,
                   triggerLabel = "Open",
                   children,
                   className = "",
                   style = {},
                   panelStyle = {},
                   panelInnerStyle = {},
                   isOpen: controlledIsOpen,
                   onOpenChange,
                   disabled = false
               }) => {
    const wrapperRef = useRef(null);
    const panelRef = useRef(null);

    const [internalIsOpen, setInternalIsOpen] = useState(false);

    const isOpen = controlledIsOpen !== undefined ? controlledIsOpen : internalIsOpen;

    const [firstTimeOpened, setFirstTimeOpened] = useState(false);

    const setIsOpenState = (value) => {
        if (controlledIsOpen === undefined) {
            setInternalIsOpen(value);
        }
        if (onOpenChange) {
            onOpenChange(value);
        }
    };

    const toggleOpen = () => setIsOpenState(!isOpen);
    const close = () => setIsOpenState(false);

    useEffect(() => {
        function handleClick(e) {
            if (
                wrapperRef.current &&
                !wrapperRef.current.contains(e.target) &&
                e.target.closest(".react-calendar") === null &&
                !e.target.classList.contains("react-calendar__tile")
            ) {
                close();
            }
        }
        function handleKey(e) {
            if (e.key === "Escape") close();
        }

        if (isOpen) {
            setFirstTimeOpened(true)
            document.addEventListener("click", handleClick);
            document.addEventListener("keydown", handleKey);
            if(panelRef.current) {
                panelRef.current.classList.remove("d-n");
            }
        }else{
            setTimeout(()=> {
                if(panelRef.current) panelRef.current.classList.add("d-n");
            }, 350);
        }

        return () => {
            document.removeEventListener("click", handleClick);
            document.removeEventListener("keydown", handleKey);
        };
    }, [isOpen]);

    useEffect(() => {
        if (isOpen && panelRef.current) {
            panelRef.current.focus();
        }
    }, [isOpen]);

    return (
        <div
            className={`popup-wrapper ${isOpen ? "is-open" : ""} ${className}`}
            ref={wrapperRef}
            style={{ display: "inline-block", position: "relative", ...style }}
        >
            <div
                className="popup-trigger"
                onClick={(e) => {
                    e.stopPropagation();
                    if(disabled)return
                    toggleOpen();
                }}
                aria-haspopup="dialog"
                aria-expanded={isOpen}
                style={{ display: "inline-block", width:'100%' }}
            >
                {trigger ? (
                    trigger
                ) : (
                    <SilverButton
                        className="popup-default-trigger"
                        onClick={(e) => {
                            e.stopPropagation();
                            toggleOpen();
                        }}
                        styles={{
                            fontSize: "14px",
                            padding: "6px 16px",
                        }}
                        height="36px"
                        disabled={disabled}
                    >
                        {triggerLabel}
                    </SilverButton>
                )}
            </div>

            <div
                ref={panelRef}
                className={
                `popup-panel ${isOpen ? "open" : firstTimeOpened ? 'closed' : "d-n"} ${direction} ` +
                    `vertical-align-${panelAlign.vertical} ` +
                    `horizontal-align-${panelAlign.horizontal} `
                }
                style={{
                    ...panelStyle,
                }}
                tabIndex={-1}
                role="dialog"
                aria-hidden={!isOpen}
                onClick={(e) => e.stopPropagation()}
            >
                <div className="popup-panel-inner" style={panelInnerStyle}>{children}</div>
            </div>
        </div>
    );
};

export default Popup;



// WEBPACK FOOTER //
// ./src/components-new/ui/Popup/index.jsx